module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-5-3a9c0f28830bdb856b0bb6eb7547d6d2.png";